import React from 'react'
import styles from '../styles/TestimonialSection.module.css'
import TestimonialSlider from '../../../components/slider/TestimonialSlider'
import Reveal from '../../../components/Animations/RevealEffect/Reveal'

const TestimonialSection = () => {
  return (
    <div>
        <section className={styles.testimonial_section_container}>
            <Reveal>
              <div className={styles.testimonial_section_header}>
                  <h3><span>Success</span> stories from our community</h3>
              </div>
            </Reveal>

            <Reveal>
              <TestimonialSlider />
            </Reveal>
        </section>
    </div>
  )
}

export default TestimonialSection
